import { Store } from '../general'

class Test extends Store {
  async init() {}
}

export default Test
